import * as Types from './types';
import { createReducer } from '../../utils/redux';

const initialState = {
  statisticsError: false,
  postingStatistics: null,
  priceStatistics: null,
  priceError: false,
  priceLoading: false,
  performanceStatus: null,
  bestPostingStatistics: null,
  loadingPostingStatistics: false,
  loadingPerformance: false,
  hasPerformanceData: false
};

const performanceReducer = createReducer(initialState)({
  [Types.FETCH_POSTING_STATISTICS]: state => ({
    ...state,
    loadingPostingStatistics: true
  }),
  [`${Types.FETCH_POSTING_STATISTICS}_COMPLETED`]: (state, action) => ({
    ...state,
    postingStatistics: action.payload,
    loadingPostingStatistics: false,
    hasPerformanceData: true
  }),
  [`${Types.FETCH_POSTING_STATISTICS}_FAILED`]: state => ({
    ...state,
    statisticsError: true,
    loadingPostingStatistics: false
  }),
  [Types.FETCH_PRICE_STATISTICS]: state => ({
    ...state,
    priceLoading: true,
    priceError: false
  }),
  [`${Types.FETCH_PRICE_STATISTICS}_COMPLETED`]: (state, action) => ({
    ...state,
    priceStatistics: action.payload,
    priceLoading: false
  }),
  [`${Types.FETCH_PRICE_STATISTICS}_FAILED`]: state => ({
    ...state,
    priceLoading: false,
    priceError: true
  }),
  [Types.FETCH_PERFORMANCE_STATUS]: state => ({
    ...state,
    loadingPerformance: true
  }),
  [Types.FETCH_PERFORMANCE_STATUS_COMPLETED]: (state, action) => ({
    ...state,
    performanceStatus: action.payload.status,
    loadingPerformance: false
  }),

  [Types.FETCH_PERFORMANCE_STATUS_FAILED]: state => ({
    ...state,
    performanceStatus: null,
    loadingPerformance: false
  }),
  [`${Types.FETCH_BEST_POSTING_STATISTICS}_COMPLETED`]: (state, action) => {
    return {
      ...state,
      bestPostingStatistics: action.payload
    };
  }
});

export { performanceReducer };
